/**
 * @@author        marlon
 * @@date          2022.07.12
 * @@desc          Calculations for Rating like average or assigning a RatingWord
 * @@usedby        SearchObjectRatingSummary
                   ObjectRatingsAggregation
 */
export default {
  i18nOptions: { namespaces: 'rating' },
  methods: {
    rcMixin_percentage(average) {
      return (average / 5) * 100;
    },
    rcMixin_averageOneDecimal(average) {
      return parseFloat(average).toFixed(1);
    },
    // assign a ratingWord dependent of average of all ratings
    rcMixin_ratingWord(average, lowerLimit) {
      // grading of RatingWords
      // https://projects.e-domizil.de/jira/browse/EDVUE-1068?focusedCommentId=770235&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-770235
      if (average >= lowerLimit) {
        let ratingWord = this.$t('rating:averageText.1');
        const votesLimits = [2, 3, 3.5, 4.0, 4.2, 4.4, 4.6, 4.8, 100]; // upper limits
        const found = votesLimits.findIndex((item) => item > average); // found item index greater ratingAverage
        ratingWord = this.$t(`rating:ratingWord.${(votesLimits[found] * 10)}`);
        return ratingWord;
      }
      return false;
    },
  },
};

